<template>
  <section>
    <app-loading v-if="loading" />

    <div v-else>
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex"></div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <div class="my-2 justify-end flex">
          <DownloadParticipations :activity="activity" />
        </div>
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">USUARIO</th>
              <th class="text-center whitespace-no-wrap">
                TIEMPO
              </th>
              <th class="text-center whitespace-no-wrap">
                PORCENTAJE
              </th>
              <th class="text-center whitespace-no-wrap">
                FECHA
              </th>
              <th class="text-center whitespace-no-wrap" v-if="activity.type === 'Extra'">
                CALIFICACIÓN
              </th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="intro-x"
              v-for="activity_user in activity.users"
              :key="`activity-${activity_user.user.slug}`"
            >
              <td class="w-40 text-center">
                <div class="text-gray-900 font-bold text-xs whitespace-no-wrap">
                  <a :href="activity.image" target="_blank">
                    {{ activity_user.user.name }}
                  </a>
                </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                    {{ activity_user.user.email }}
                  </div>
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                    <a :href="activity.image" target="_blank">
                      {{ activity_user.user.team ? activity_user.user.team.name : ''}}
                    </a>
                  </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity_user.time_to_respond }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity_user.percentage_correct }}%
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity_user.created_at }}
                </div>
              </td>
              <td class="w-40 text-center" v-if="activity.type === 'Extra'">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity_user.qualification === null ? 'Sin Calificar' : ( activity_user.qualification == true ? 'Aprobado' : 'Rechazado') }}
                </div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex flex-wrap justify-center items-center">
                  <router-link v-if="activity.type !== 'Extra'"
                    :to="`/admin/activities/${activity_user.slug}/answers`"
                    class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="folder" classname="w-4 h-4 mr-2" />Ver
                    Respuestas
                  </router-link>
                  <button v-if="activity.type === 'Extra' && activity_user.qualification === null"
                    @click="showQualificationModal(activity_user.slug, activity_user.answer)"
                    class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="eye" classname="w-4 h-4 mr-2" />Calificar
                  </button>
                  <button
                    @click="showDeleteModal(activity_user.slug)"
                    class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md"
                  >
                    <app-icon name="trash" classname="w-4 h-4 mr-2" />Eliminar
                    Participación
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <Modal
      title="Eliminar Participación"
      @close="closeDeleteModal"
      size="lg"
      v-if="showParticipationDeleteModal"
    >
      <form @submit.prevent="submitDeleteModal()">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="mt-3 col-span-12 text-center">
            <div>Esta seguro de eliminar la Participación?</div>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            data-dismiss="modal"
            class="button w-20 border text-gray-700 mr-1"
            @click="closeDeleteModal"
          >
            Cancelar
          </button>
          <button type="submit" class="button w-20 bg-theme-1 text-white">
            Eliminar
          </button>
        </div>
      </form>
    </Modal>

    <Modal
      title="Calificar Participación"
      @close="closeQualificationModal"
      size="lg"
      v-if="showParticipationQualificationModal"
    >
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="mt-3 col-span-12 text-center">
            <div>{{answer}}</div>
            <div class="mt-3 flex justify-center gap-5">
              <button type="button" @click="submitQualificationModal(true)" class="button w-20 bg-theme-1 text-white">
                Aprobar
              </button>
              <button type="button" @click="submitQualificationModal(false)" class="button w-20 bg-theme-4 text-white">
                Rechazar
              </button>
            </div>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
          <button
            type="button"
            data-dismiss="modal"
            class="button w-20 border text-gray-700 mr-1"
            @click="closeQualificationModal"
          >
            Cancelar
          </button>
        </div>
    </Modal>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/services/axios'
import Icon from '@/components/admin/partials/Icon'
import Modal from '@/components/assets/Modal/Modal'
import Loading from '@/components/admin/partials/LoadingWhite'
import DownloadParticipations from '@/components/admin/activity/DownloadParticipations'

export default {
  name: 'AdminListActivityParticipations',
  data() {
    return {
      loading: false,
      activity: {},
      showParticipationDeleteModal: false,
      deleteParticipationSlug: null,
      showParticipationQualificationModal: false,
      participationQualificationSlug: null,
      answer: null,
    }
  },
  async beforeMount() {
    await this.getAcitivtyParticipations()
  },
  methods: {
    ...mapActions(['get']),
    async getAcitivtyParticipations() {
      this.loading = true
      try {
        const { model } = await this.get(
          `/activity/${this.$route.params.slug}/participations`
        )
        this.activity = model
      } catch (error) {
        this.$router.push('/admin/activities')
      } finally {
        this.loading = false
      }
    },
    async deleteActivityUser(activityUSerSlug) {
      try {
        const {
          data: { message },
        } = await axios.delete(
          `/activity/${this.$route.params.slug}/participations/${activityUSerSlug}`
        )

        await this.getAcitivtyParticipations()

        window.$toast.info(message)
      } catch (error) {
        console.log(error)
      }
    },
    showDeleteModal(slug) {
      this.deleteParticipationSlug = slug
      this.showParticipationDeleteModal = true
    },
    closeDeleteModal() {
      this.deleteParticipationSlug = null
      this.showParticipationDeleteModal = false
    },
    showQualificationModal(slug,answer) {
      this.participationQualificationSlug = slug
      this.showParticipationQualificationModal = true
      this.answer = answer
    },
    closeQualificationModal() {
      this.participationQualificationSlug = null
      this.showParticipationQualificationModal = false
      this.answer = null
    },
    async submitDeleteModal() {
      try {
        await this.deleteActivityUser(this.deleteParticipationSlug)
        this.closeDeleteModal()
      } catch (error) {
        console.log(error)
      }
    },
    async submitQualificationModal(qualification) {
      try {
        const { message } = await axios.post(
          `/qualification-extra/${this.participationQualificationSlug}`,
          {
            qualification: qualification,
          }
        )
        window.$toast.info(message)
        this.closeQualificationModal()
        location.reload()
      } catch (error) {
        console.log(error)
      }
    },
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    Modal,
    DownloadParticipations,
  },
}
</script>



// WEBPACK FOOTER //
// ListParticipations.vue?6de2cb34